module.exports = {"elasticsearchHost":"wma-elasticsearch.staging.flightstats.io:9200","usersHost":"https://users.iad.staging.flightstats.io","billingHost":"https://wma-k8s.iad.staging.flightstats.io/wma-billing/api","flightAlertsHost":"http://wma-k8s.iad.staging.flightstats.io/wma-flight-alerts/api","dataExportsHost":"http://wma-k8s.iad.staging.flightstats.io/wma-data-exports/api","redisHost":"wma-web-staging-001.huxzox.0001.use1.cache.amazonaws.com","redisPort":6379}


//////////////////
// WEBPACK FOOTER
// ./config/config-test.json
// module id = 3124
// module chunks = 1